/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Start_Blank_OfflineInputs */

const en_us2_plan_build_start_blank_offline = /** @type {(inputs: Plan_Build_Start_Blank_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to start a plan from scratch.`)
};

const pt_br2_plan_build_start_blank_offline = /** @type {(inputs: Plan_Build_Start_Blank_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para começar um plano do zero, conecte-se à internet.`)
};

const es_419_plan_build_start_blank_offline = /** @type {(inputs: Plan_Build_Start_Blank_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctate a internet para empezar un plan desde cero.`)
};

const pt_pt2_plan_build_start_blank_offline = /** @type {(inputs: Plan_Build_Start_Blank_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para começar um plano do zero, liga-te à internet.`)
};

const fr_fr2_plan_build_start_blank_offline = /** @type {(inputs: Plan_Build_Start_Blank_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecte-toi à Internet pour commencer un programme de zéro.`)
};

const de_de2_plan_build_start_blank_offline = /** @type {(inputs: Plan_Build_Start_Blank_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde dich mit dem Internet, um einen Plan von vorn zu beginnen.`)
};

const it_it2_plan_build_start_blank_offline = /** @type {(inputs: Plan_Build_Start_Blank_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connettiti a internet per iniziare una scheda da zero.`)
};

/**
* | output |
* | --- |
* | "Connect to the internet to start a plan from scratch." |
*
* @param {Plan_Build_Start_Blank_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_start_blank_offline = /** @type {((inputs?: Plan_Build_Start_Blank_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Start_Blank_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_start_blank_offline(inputs)
	if (locale === "es-419") return es_419_plan_build_start_blank_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_start_blank_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_start_blank_offline(inputs)
	if (locale === "de-DE") return de_de2_plan_build_start_blank_offline(inputs)
	if (locale === "it-IT") return it_it2_plan_build_start_blank_offline(inputs)
	return en_us2_plan_build_start_blank_offline(inputs)
});
export { plan_build_start_blank_offline as "plan-build.start_blank_offline" }